import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../shared/services/notification.service';
import { SpecialPricingGroupFormComponent } from '../special-pricing-group-form/special-pricing-group-form.component';

@Component({
  standalone: false,
  selector: 'app-special-pricing-group-create',
  templateUrl: './special-pricing-group-create.component.html',
})
export class SpecialPricingGroupCreateComponent {
  @ViewChild(SpecialPricingGroupFormComponent, { static: false }) form;

  loading = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public notificationService: NotificationService,
    titleService: Title
  ) {
    titleService.setTitle('Special pricing group create');
  }

  afterSave() {
    this.router.navigate(['/pricing-special']).then();
  }
}
